import {Inject, Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {ConfigService} from '@docma-mm-core/config/config.service';
import {BasedataService} from '@docma-mm-core/shared/basedata.service';
import {MYDOCMASETTINGS} from '@mydocma/core';
import {MydocmaSettings} from '@mydocma/core';
import {catchError, Observable, of} from 'rxjs';
import {joinUrl} from '@docma-mm-core/utils/utils';

@Injectable()
export class SchemaApiService extends BasedataService {

  private readonly mydocmaUrl = `${this.mydocmaConfig.apiUrl}`;

  constructor(private http: HttpClient,
              @Inject(MYDOCMASETTINGS) private mydocmaConfig: MydocmaSettings,
              configService: ConfigService) {

    super(configService);
  }

  getAll(customerId: string): Observable<any[]> {
    const endpoint = joinUrl(this.mydocmaUrl, `/customers/${customerId}/schemas`);

    let httpParams = new HttpParams();
    httpParams = httpParams.set('app_id', this.mydocmaConfig.appId);

    return this.http.get<any[]>(endpoint, { headers: this.getHeaders(), params: httpParams })
      .pipe(catchError(e  => this.handleError(e)));
  }

}
